'use client';

import { useTranslations } from 'next-intl';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { Typography } from '@/components/ui/typography';
import { SectionHeading } from '@/components/frontend/home/section-heading';
import { useScrollAnimation } from '@/hooks/use-scroll-animation';

interface CountryFeaturesSectionProps {
    translationNamespace: string;
}

export function CountryFeaturesSection({ translationNamespace }: CountryFeaturesSectionProps) {
    const t = useTranslations(translationNamespace);
    const sectionRef = useScrollAnimation({ threshold: 0.15 });

    return (
        <SectionWrapper
            ref={sectionRef.ref}
            variant="default"
            padding="md"
            className="relative overflow-hidden"
        >
            <div className="pointer-events-none absolute inset-0 opacity-40">
                <div className="absolute left-10 top-10 h-80 w-80 rounded-full bg-primary-500/10 blur-3xl" />
                <div className="absolute right-10 bottom-10 h-80 w-80 rounded-full bg-blue-500/10 blur-3xl" />
            </div>

            <div className={`relative z-10 container mx-auto transition-all duration-700 ${sectionRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
                }`}>
                <div className="max-w-4xl mx-auto">
                    {/* Features Section */}
                    <SectionHeading
                        pill={t('features.pill')}
                        title={t('features.title')}
                        subtitle={t('features.subtitle')}
                        align="center"
                        maxWidthClass="max-w-4xl"
                        isVisible={sectionRef.isVisible}
                    />

                    {/* Best Company Section */}
                    <div className={`bg-gray-50 dark:bg-gray-900 rounded-xl p-8 border border-gray-200 dark:border-gray-800 transition-all duration-700 ${sectionRef.isVisible
                        ? 'opacity-100 translate-y-0 scale-100'
                        : 'opacity-0 translate-y-6 scale-95'
                        }`} style={{ transitionDelay: '300ms' }}>
                        <Typography variant="h2" className="mb-6 text-center">
                            {t('bestCompany.title')}
                        </Typography>
                        <Typography variant="p" className="text-lg text-gray-700 dark:text-gray-300 text-center">
                            {t('bestCompany.description')}
                        </Typography>
                    </div>
                </div>
            </div>
        </SectionWrapper>
    );
}

